"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/JOFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_119)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_119`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0H36V24H0V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0H36V8H0V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 16H36V24H0V16Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 11.9789L0 23.9509V0L18 11.9789Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.46668 9.78943L6.02107 10.9403L7.27019 10.6526L6.70879 11.8105L7.7123 12.6035L6.46317 12.8842L6.47019 14.1684L5.46668 13.3614L4.47019 14.1684V12.8842L3.22107 12.6035L4.22458 11.8105L3.67019 10.6526L4.9123 10.9403L5.46668 9.78943Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_119`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as JOFlag };
